import { forEachParam } from './forEachParam.js';
import { store } from '@/store/index.js';

/**
 * @name dispatchByParam
 * @description Call a store action if a passed param is present on the route
 * @param {Object} params - Keys are the param and the value is the store action to be called
 * @returns undefined
 *
 * @example
 * // triggers the "club/getById" store action if the "clubId" param is found on the route
 * router.beforeEach(dispatchByParam({
 *     clubId: `club/getById`
 * }));
 */
function dispatchByParam (params) {
	return async to => {
		// an array of params that are present on the route and the "params" variable
		const foundParams = Object.entries(
			to.params
		).filter(param => Object.keys(params).includes(param[0]));

		if (!foundParams.length) return;

		await forEachParam(
			foundParams,
			async (key, value) => await store.dispatch(params[key], value)
		);
	};
}

export { dispatchByParam };
